import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store from "./helpers/store/Store";
import reportWebVitals from "./reportWebVitals";

// Vendor scripts
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js"; // allows animations to work
import "bootswatch/dist/slate/bootstrap.css"; // this is the bootswatch theming

//SCSS
import "./styles/styles.scss";

const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
